export default () => ({
  schedules: {},
  show: false,
  showTotal: true,
  text: 'Aguarde Processando...',
  dark: false,
  classes: null,
  background: null,
  customLoader: null,
  mbloading: false
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/schedule/resources/data.js